import React from "react";
import "./Requirement.css";
const Requirement = () => {
  const data = [
    {
      id: 1,
      img: require("../../Assets/img12.png"),
      title: "Medical Certification",
    },
    {
      id: 2,
      img: require("../../Assets/img13.png"),
      title: "State Licensure / Board Certification",
    },
    {
      id: 3,
      img: require("../../Assets/img14.png"),
      title: "Contractual Agreement with Wihan",
    },
  ];
  return (
    <>
      <div className="partner-section">
        <h1 className="heading-h1">Requirements</h1>
        <div className="three-card">
          {data?.map((item) => {
            return (
              <div className="requirement-card" key={item.id}>
                <img src={item?.img} alt="" className="requirement-img" />
                <div className="data-flex">
                  {/* <input type="checkbox" className="requirement-checkbox" id={`check-${item.id}`} /> */}
                  <img
                    src={require("../../Assets/check-mark (1).png")}
                    alt=""
                    className="requirement-checkbox"
                  />
                  <p className="requirement-text">{item?.title}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default Requirement;
